module.exports = __webpack_public_path__ + "img/a-ziyuan8.da7351e4.png";